export const PRIVACY_CLASS = {
  EXCLUDE: 'fs-exclude',
  MASK: 'fs-mask',
};
